import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		padding: SPACE[16],
	},
	notice: {
		backgroundColor: THEME.colors.info.light,
		borderLeft: `4px solid ${THEME.colors.info.main}`,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		padding: SPACE[12],
	},
	activityLink: {
		alignItems: 'center',
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		gap: SPACE[16],
		justifyContent: 'space-between',
		padding: SPACE[16],
	},
	activityLinkText: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
		minWidth: 0,
	},
	activityLinkTitle: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	activityLinkDescription: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	activityLinkAction: {
		flexShrink: 0,
	},
});
